import { ChangeDetectorRef, Component, Input, Inject } from "@angular/core";
import * as GoldenLayout from "golden-layout";

import { AfterViewChecked, OnChanges } from "@angular/core";
import { UserService } from "@app/services/user.service";
import { User } from "@app/data/user";
import { GoldenLayoutService } from "@app/services/golden-layout.service";
import { GoldenLayoutBaseComponent } from "@app/components/editor/workspace/golden-layout-base.component";
import {
  TEXT_COMPONENT_KEY,
  LISTING_INFORMATION_COMPONENT_KEY,
} from "@app/components/editor/workspace/golden-layout-definitions";
import { SimpleChanges } from "@angular/core";
import { PipeTransform } from "@angular/core";
import { Pipe } from "@angular/core";
import { Listing } from "@app/data/listing";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { SecurityContext } from "@angular/core";
import { CurrencyPipe } from "@angular/common";
import * as tearSheetUtils from "@js/tear-sheet.utils";
import {
  GoldenLayoutComponentState,
  GoldenLayoutContainer,
} from "golden-layout/golden-layout.directive";

@Pipe({
  name: "replaceListingTags",
  pure: false,
})
export class ReplaceListingTagsPipe implements PipeTransform {
  oldListingString: string;
  oldHtml: string;
  templateHtml: SafeHtml;
  previewHtml: SafeHtml;

  constructor(
    private userService: UserService,
    private sanitizer: DomSanitizer,
    private currencyPipe: CurrencyPipe
  ) {}

  transform(html: string, listing: Listing, preview: boolean): any {
    var listingString = JSON.stringify(listing);
    if (listingString !== this.oldListingString || html !== this.oldHtml) {
      this.oldHtml = html;
      this.oldListingString = listingString;
      if (preview) {
        this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(
          tearSheetUtils.replaceListingInformation(
            this.userService.locale(),
            html,
            listing
          )
        );
      }
      this.templateHtml = this.sanitizer.bypassSecurityTrustHtml(html);
    }
    if (preview) {
      return this.previewHtml;
    }
    return this.templateHtml;
  }
}

@Component({
  templateUrl: "./golden-layout-listing-information.component.html",
})
export class GoldenLayoutListingInformationComponent extends GoldenLayoutBaseComponent {
  listing: Listing;

  constructor(
    @Inject(GoldenLayoutComponentState) state: any,
    @Inject(GoldenLayoutContainer) container: GoldenLayout.Container,
    goldenLayoutService: GoldenLayoutService,
    cdRef: ChangeDetectorRef
  ) {
    super(state, container, goldenLayoutService, cdRef);
    this.goldenLayoutService.getListing().subscribe((listing) => {
      this.listing = listing;
    });
  }
  onClick() {
    console.log("clicked on listing information component key");
    this.select(LISTING_INFORMATION_COMPONENT_KEY);
  }
}
